goog.provide("shadow.js.shim.module$$mui$material$Checkbox");
goog.provide("module$shadow_js_shim_module$$mui$material$Checkbox");
shadow.js.shim.module$$mui$material$Checkbox = shadow.js.nativeProvides["@mui/material/Checkbox"] = shadow$bridge("@mui/material/Checkbox");
module$shadow_js_shim_module$$mui$material$Checkbox.default = shadow.js.shim.module$$mui$material$Checkbox;
